// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bewertung-auswertung-screen{
  position: relative;
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}

/* SIDE SELECTOR START*/

.selector-container{  
  position: relative;
  display: flex;
  flex-direction: row;
  top: 35px;
  height: fit-content;
  margin-right: 42px;
  margin-left: 42px;
  border-radius: 10px;
  background: var(--searchbar-background);

  /*Text Font*/
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.selector-item-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  background: var(--white-base);
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-item-not-selected {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  width: 100%;
  text-align: center; /* Center text within the flex container */
}

.selector-divider {
  width: 1.48px;
  height: 50.8px;
  background-color: var(--gray-20);
  margin: 10px;
}
/* SIDE SELECTOR END */

/* MAIN CONTENT START*/
.singleContent-container {
  position: relative;
  min-width: 500px;
  overflow-x: scroll;
  margin-top: 80px;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
  margin-bottom: 118px;
  /* Add vertical gap between children */
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 30px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
  
  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

.singleContent-container-table {
  position: relative;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
  /* Add vertical gap between children */
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 30px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);
  
  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
}

  .HeaderCell-Custom-meinAssessment {
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    position: relative; /* Make sure to set a position other than static */
    z-index: 1 !important; /* Set a higher z-index value */
  }

  .ba-singleContent-container-selector-doubleSelector {
    position: relative;
    margin-right: 0;
    margin-left: auto;
    padding: 0px 5px;
    width: fit-content;
    margin-right: 5px;
    
    border-radius: 8px;
    border: none;
    cursor: pointer;

    /* TEXT FONT */
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */

    display: flex;
    gap: 10px;
    background-color: none !important;
  }

  .ba-singleContent-container-selector-s1{
    position: relative;
    margin-right: 0;
    margin-left: auto;
    padding: 5px 10px;
    width: fit-content;
    background-color: var(--gray-20);
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    /* TEXT FONT */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */
  }
  .ba-singleContent-container-selector-item {
    background-color: white; /* Background color for options */
    color: var(--white-base);
  }

  .singleContent-container-titel{
    font-size: 25px;
    font-weight: bold;
    width: fit-content;
  }
    .progressBar-background{
      margin: 7px 10px;
      width: 100%;
      border: none;
      border-radius: 10px;
      background-color: var(--gray-20);
    }
    .progressBar-progress-1{
      width: 20%;
      height: 100%;
      border-radius: 10px;
      background-color: var(--assessment-lv1);
    }
    .progressBar-progress-2{
      width: 40%;
      height: 100%;
      border-radius: 10px;
      background-color: var(--assessment-lv2);
    }
    .progressBar-progress-3{
      width: 60%;
      height: 100%;
      border-radius: 10px;
      background-color: var(--assessment-lv3);
    }
    .progressBar-progress-4{
      width: 80%;
      height: 100%;
      border-radius: 10px;
      background-color: var(--assessment-lv4);
    }
    .progressBar-progress-5{
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background-color: var(--assessment-lv5);
    }


  .tableLevel-background {
    margin: 1px 20%;
    padding-top: 2%;
    width: 100%;
    border: none;
    border-radius: 5px;
    color: var(--white-base);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8% 15%;
  }

  .tableLevel-background-1{
    background-color: var(--assessment-lv1);
  }
  .tableLevel-background-2{
    background-color: var(--assessment-lv2);
  }
  .tableLevel-background-3{
    background-color: var(--assessment-lv3);
  }
  .tableLevel-background-4{
    background-color: var(--assessment-lv4);
  }
  .tableLevel-background-5{
    background-color: var(--assessment-lv5);
  }
.singleContent-container-tableheader{
  margin-left: 15px;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  color: black;
}

/* MAIN CONTENT END*/`, "",{"version":3,"sources":["webpack://./src/pages/BewertungAuswertung.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;EAEE;IACE,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB,EAAE,kDAAkD;IACtE,qBAAqB,EAAE,+BAA+B;EACxD;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;;IAEjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;;IAEf,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;;IAE5B,aAAa;IACb,SAAS;IACT,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,eAAe;;IAEf,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;EACA;IACE,uBAAuB,EAAE,iCAAiC;IAC1D,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;IACE;MACE,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,gCAAgC;IAClC;IACA;MACE,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,uCAAuC;IACzC;IACA;MACE,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,uCAAuC;IACzC;IACA;MACE,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,uCAAuC;IACzC;IACA;MACE,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,uCAAuC;IACzC;IACA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,uCAAuC;IACzC;;;EAGF;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;AACF;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA,oBAAoB","sourcesContent":[".bewertung-auswertung-screen{\r\n  position: relative;\r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n/* SIDE SELECTOR START*/\r\n\r\n.selector-container{  \r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  top: 35px;\r\n  height: fit-content;\r\n  margin-right: 42px;\r\n  margin-left: 42px;\r\n  border-radius: 10px;\r\n  background: var(--searchbar-background);\r\n\r\n  /*Text Font*/\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.selector-item-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  background: var(--white-base);\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-item-not-selected {\r\n  display: flex;\r\n  align-items: center; /* Center vertically */\r\n  justify-content: center; /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  width: 100%;\r\n  text-align: center; /* Center text within the flex container */\r\n}\r\n\r\n.selector-divider {\r\n  width: 1.48px;\r\n  height: 50.8px;\r\n  background-color: var(--gray-20);\r\n  margin: 10px;\r\n}\r\n/* SIDE SELECTOR END */\r\n\r\n/* MAIN CONTENT START*/\r\n.singleContent-container {\r\n  position: relative;\r\n  min-width: 500px;\r\n  overflow-x: scroll;\r\n  margin-top: 80px;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n  margin-bottom: 118px;\r\n  /* Add vertical gap between children */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n  \r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%; /* 18px */\r\n}\r\n\r\n.singleContent-container-table {\r\n  position: relative;\r\n  margin-top: 10px;\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  margin-bottom: 20px;\r\n  /* Add vertical gap between children */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n  \r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%; /* 18px */\r\n}\r\n\r\n  .HeaderCell-Custom-meinAssessment {\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n    position: relative; /* Make sure to set a position other than static */\r\n    z-index: 1 !important; /* Set a higher z-index value */\r\n  }\r\n\r\n  .ba-singleContent-container-selector-doubleSelector {\r\n    position: relative;\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n    padding: 0px 5px;\r\n    width: fit-content;\r\n    margin-right: 5px;\r\n    \r\n    border-radius: 8px;\r\n    border: none;\r\n    cursor: pointer;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 150%; /* 18px */\r\n\r\n    display: flex;\r\n    gap: 10px;\r\n    background-color: none !important;\r\n  }\r\n\r\n  .ba-singleContent-container-selector-s1{\r\n    position: relative;\r\n    margin-right: 0;\r\n    margin-left: auto;\r\n    padding: 5px 10px;\r\n    width: fit-content;\r\n    background-color: var(--gray-20);\r\n    border-radius: 8px;\r\n    border: none;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    cursor: pointer;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 150%; /* 18px */\r\n  }\r\n  .ba-singleContent-container-selector-item {\r\n    background-color: white; /* Background color for options */\r\n    color: var(--white-base);\r\n  }\r\n\r\n  .singleContent-container-titel{\r\n    font-size: 25px;\r\n    font-weight: bold;\r\n    width: fit-content;\r\n  }\r\n    .progressBar-background{\r\n      margin: 7px 10px;\r\n      width: 100%;\r\n      border: none;\r\n      border-radius: 10px;\r\n      background-color: var(--gray-20);\r\n    }\r\n    .progressBar-progress-1{\r\n      width: 20%;\r\n      height: 100%;\r\n      border-radius: 10px;\r\n      background-color: var(--assessment-lv1);\r\n    }\r\n    .progressBar-progress-2{\r\n      width: 40%;\r\n      height: 100%;\r\n      border-radius: 10px;\r\n      background-color: var(--assessment-lv2);\r\n    }\r\n    .progressBar-progress-3{\r\n      width: 60%;\r\n      height: 100%;\r\n      border-radius: 10px;\r\n      background-color: var(--assessment-lv3);\r\n    }\r\n    .progressBar-progress-4{\r\n      width: 80%;\r\n      height: 100%;\r\n      border-radius: 10px;\r\n      background-color: var(--assessment-lv4);\r\n    }\r\n    .progressBar-progress-5{\r\n      width: 100%;\r\n      height: 100%;\r\n      border-radius: 10px;\r\n      background-color: var(--assessment-lv5);\r\n    }\r\n\r\n\r\n  .tableLevel-background {\r\n    margin: 1px 20%;\r\n    padding-top: 2%;\r\n    width: 100%;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: var(--white-base);\r\n    font-weight: bold;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8% 15%;\r\n  }\r\n\r\n  .tableLevel-background-1{\r\n    background-color: var(--assessment-lv1);\r\n  }\r\n  .tableLevel-background-2{\r\n    background-color: var(--assessment-lv2);\r\n  }\r\n  .tableLevel-background-3{\r\n    background-color: var(--assessment-lv3);\r\n  }\r\n  .tableLevel-background-4{\r\n    background-color: var(--assessment-lv4);\r\n  }\r\n  .tableLevel-background-5{\r\n    background-color: var(--assessment-lv5);\r\n  }\r\n.singleContent-container-tableheader{\r\n  margin-left: 15px;\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  color: black;\r\n}\r\n\r\n/* MAIN CONTENT END*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
